// fix codegen staging
// xp:expo-cube-client $ amplify codegen remove
// xp:expo-cube-client $ amplify codegen add --apiId hwlh4dpe55gvrofcftzje4f7ae

// staging
export const infra = {
    aws_project_region: 'eu-west-1',
    aws_appsync_graphqlEndpoint: 'https://un5a5n7ydnexje5slzytfkmk4i.appsync-api.eu-west-1.amazonaws.com/graphql',
    aws_appsync_region: 'eu-west-1',
    aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
    Auth: {
        identityPoolId: 'eu-west-1:6072c010-071c-4ffc-919d-ebf60b38a188',
        region: 'eu-west-1',
        identityPoolRegion: 'eu-west-1',
        userPoolId: 'eu-west-1_hU1CJMtTn',
        userPoolWebClientId: '7aq7vg0tcq2ub8i5bs17s6movb',
        mandatorySignIn: false,
    }
};

export const LOG_LEVEL = 'INFO';
